import React from "react";
import './footer.css'; 

function Footer() {
  return (
    <footer>
      <p>© 2023-2024 Güz dönemi bitirme projesi kapsamında hazırlanmıştır ve telif hakları saklıdır. İzinsiz kullanımı yasaktır.</p>
    </footer>
  );
}

export default Footer;
